module.exports = __webpack_public_path__ + "static/img/img6.bb91e38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/product/images/img6.jpg
// module id = BeTH
// module chunks = 1